import {
  getRotationRules as getRotationRulesApi,
  getRotationRuleMeta as getRotationRuleMetaApi,
  getRotationRuleById as getRotationRuleByIdApi,
} from 'services/axios/rotationRules'

export const actions = {
  SET_LOADING: 'rotationRules/SET_LOADING',
  SET_RULES: 'rotationRules/SET_RULES',
  SET_META: 'rotationRules/SET_META',
  SET_PAGINATION: 'rotationRules/SET_PAGINATION',
  SET_FILTERS: 'rotationRules/SET_FILTERS',
  RESET_FILTERS: 'rotationRules/RESET_FILTERS',
}

export const setRotationRuleLoading = (loading) => ({
  type: actions.SET_LOADING,
  payload: loading,
})

export const setRotationRulePagination = (pagination) => ({
  type: actions.SET_PAGINATION,
  payload: pagination,
})

export const setRotationRuleFilters = (filters) => ({
  type: actions.SET_FILTERS,
  payload: filters,
})

export const resetRotationRuleFilters = () => ({
  type: actions.RESET_FILTERS,
})

export const getRotationRules = (params) => {
  return async (dispatch) => {
    dispatch(setRotationRuleLoading(true))

    try {
      const response = await getRotationRulesApi(params)

      dispatch({
        type: actions.SET_RULES,
        payload: {
          rules: response?.data?.data?.rotationRules || [],
          totalCount: response?.data?.data?.totalCount || 0,
        },
      })
    } finally {
      dispatch(setRotationRuleLoading(false))
    }
  }
}

export const getRotationRuleMeta = () => {
  return async (dispatch) => {
    const response = await getRotationRuleMetaApi()

    dispatch({
      type: actions.SET_META,
      payload: {
        shifts: response?.data?.data?.shifts || [],
      },
    })
  }
}

export const getRotationRuleById = (id) => {
  return async (dispatch) => {
    dispatch(setRotationRuleLoading(true))

    try {
      const response = await getRotationRuleByIdApi(id)

      return response?.data?.data || null
    } finally {
      dispatch(setRotationRuleLoading(false))
    }
  }
}
